import React from 'react';
import SectionHeader from '../SectionHeader';
import Route from '../../../../enums/route';
import { KPMGCalculationsLinkIcon, KPMGDocumentsLinkIcon } from '../../../../assets/icons';
import { automationIds } from '../../../../constants/automationIds';
import NavigationLink from '../NavigationLink';
import AccessPolicy from '../../../../enums/accessPolicy';
const WorkspaceSection = () => (<>
    <SectionHeader title='SIDER.HEADER.WORKSPACE'/>
    <NavigationLink to={Route.Calculations} icon={<KPMGCalculationsLinkIcon />} title='SIDER.LINK.CALCULATIONS' policy={{ id: AccessPolicy.ViewCalculations }} automationId={automationIds.NAV_LINK.CALCULATIONS}/>
    <NavigationLink to={Route.Documents} icon={<KPMGDocumentsLinkIcon />} title='SIDER.LINK.DOCUMENTS' policy={{ id: AccessPolicy.ViewDocuments }} automationId={automationIds.NAV_LINK.DOCUMENTS}/>
  </>);
export default WorkspaceSection;
